<template>
  <div class="settings">
    <el-collapse>
      <el-collapse-item title="Base">
        <div class="flex flex-column mb2">
          <label class="mb1" for="">Label</label>
          <el-input placeholder="Label" v-model="label"></el-input>
        </div>
        <div class="flex flex-column mb2">
          <label class="mb1" for="">Description</label>
          <el-input
            type="textarea"
            :rows="3"
            placeholder="Description"
            v-model="description">
          </el-input>
        </div>
        <div class="flex flex-column mb2">
          <el-checkbox v-model="required">Required</el-checkbox>
        </div>
      </el-collapse-item>
      <el-collapse-item title="Advanced options">
        <div class="flex flex-column mb2">
          <label class="mb1" for="">Limit</label>
          <el-input-number
            class="number-input"
            placeholder="maximum number of uploads allowed"
            v-model="limit"
            :step="1"
            :min="1"></el-input-number>
          <small>Maximum number of uploads allowed</small>
        </div>
        <div class="flex flex-column mb2">
          <label class="mb1" for="">Accept</label>
          <el-input placeholder="Acceptable file types" v-model="accept" />
          <small>Leave this empty to allow all</small>
        </div>
        <div class="flex flex-column mb2">
          <label class="mb1" for="">Max file size (mb)</label>
          <el-input placeholder="Megabytes" v-model="maxFileSize" />
          <small>Enter the max size of each file, in megabytes, to allow. If left blank, the value defaults to the maximum size the server allows.</small>
        </div>
        <div class="flex flex-column mb2">
          <label class="mb1" for="">CSS Classes</label>
          <el-input placeholder="Enter CSS class names for the form field container" v-model="className"></el-input>
        </div>
        <div class="flex flex-column mb2">
          <el-checkbox v-model="storeInMedia">Store file in Media Library</el-checkbox>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import fieldData from './index'
import refsFactory from '../../../composables/refsFactory'
import addWatch from '../../../composables/addWatch'
import defaultFieldDispatch from '../../../utils/defaultFieldDispatch'

export default {
  name: 'uploader-settings',
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  setup (props, { emit }) {
    return addWatch(
      refsFactory(
        props,
        Object.keys(fieldData.data.value)
      ),
      defaultFieldDispatch(emit)
    )
  }
}
</script>

<style scoped lang="scss">
.number-input{
  width: 100%;
}
</style>
